import { useState } from 'react'
import { cn } from '@/lib/cn'
import { initialsOf } from '@/lib/format'
import styles from './Avatar.module.css'

interface AvatarProps {
  name: string | null | undefined
  src?: string | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

/**
 * Profile image with an initials fallback.
 *
 * Driver photos are uploaded by admins and served from the API host; a broken or
 * missing URL falls back to initials rather than a broken-image icon.
 */
export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  const [failed, setFailed] = useState(false)
  const showImage = Boolean(src) && !failed

  return (
    <span className={cn(styles.avatar, styles[size], className)} aria-hidden="true">
      {showImage ? (
        <img src={src ?? ''} alt="" loading="lazy" onError={() => setFailed(true)} />
      ) : (
        <span className={styles.initials}>{initialsOf(name)}</span>
      )}
    </span>
  )
}
